// extracted by mini-css-extract-plugin
module.exports = {"root":"AddFavorites_root__sOoyQ","simpleIcon":"AddFavorites_simpleIcon__1Q82-","icon":"AddFavorites_icon__35Y17","iconActive":"AddFavorites_iconActive__3pQEp"};